// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});
// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
import { faFacebook, faTwitter, faInstagram, faLinkedin, faYoutube,faWhatsapp, faLine, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faPlus, faMinus, faPhone, faAt, faEnvelope, faMapMarker, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

// add the imported icons to the library
library.add(faFacebook, faTwitter, faInstagram, faLinkedin, faYoutube, faPlus, faMinus, faPhone, faAt, faEnvelope, faMapMarker, faExternalLinkAlt, faWhatsapp, faLine, faTiktok );
import 'fancybox/dist/js/jquery.fancybox.js'; 
// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();
// Load Events
jQuery(document).ready(() => routes.loadEvents());
